import { msg } from '@lingui/macro';
import { md } from 'content/types';

export default {
  title: () => msg`Tell us about your healthcare balances and contributions`,
  intro: () =>
    md(msg`
Let us know about any balances you may have in healthcare related accounts. This information will help us to find a mix of helpful saving strategies that is right for you. 
${'_lf'}
If you do not have balances in these types of accounts, please leave these fields blank and click “Save and Continue” and see your results.`),

  whyDoWeNeedThis: md(
    msg`Since an HSA allows account owners to pay for current and save for future
qualified healthcare expenses, this information helps us calculate how your
HSA savings may cover your estimated, projected out-of-pocket costs and how
hypothetical investment returns may help cover healthcare services in retirement.`,
  ),

  callout: md(msg`
Health Savings Accounts are only available with high-deductible health plans
(HDHP). An HSA is a way for you and your household to contribute, save and pay
for eligible medical expenses now and into retirement as long as you have funds
in your account. It helps you cover out-of-pocket qualified medical expenses
with the added bonus of tax savings when you are enrolled in a high deductible health plan.`),

  balanceDescription: () => msg`If you do not have an HSA balance, please 
leave this field blank and click “Save and Continue” and see your results.`,
};
